<div class="flex flex-col h-full">

  <!-- Messages area -->
  <div class=" min-h-80 max-h-[600px] flex-1 overflow-y-auto px-2 space-y-4">

    @if (comments().length === 0) {
      <div class="flex flex-col items-center justify-center h-full text-center text-surface-400 select-none">
        <i class="pi pi-comments text-4xl mb-3 opacity-40"></i>
        <p class="text-sm font-medium">{{ 'app.no-comment' | translate }}</p>
      </div>
    }

    <div class="flex flex-col gap-2">
      @for (comment of comments(); track comment.id) {

        <elcia-todo-comment-item [comment]="comment"/>
      }
    </div>

  </div>


  <div class="px-2">
    <p-divider/>
    <div class="flex items-end gap-2">

      <elcia-text-area
        #textAreaComp
        (inputEvent)="onInput($event)"
        (keydownEvent)="onKeydown($event)"
        [control]="messageControl"
        [placeholder]="'todo.comment-placeholder' | translate"
        [rows]="2"
        class="flex-1"
      />
    </div>

  </div>

</div>

<!-- Mention overlay -->
<p-popover #mentionOverlay>
  <div class="min-w-48 max-w-64">

    @if (mentionType() === 'user') {
      <ul aria-label="User mentions" class="py-1" role="listbox">
        @for (user of filteredUsers(); track user.id; let i = $index) {
          <li
            (click)="selectUser(user)"
            [class.bg-primary-50]="mentionActiveIndex() === i"
            class="flex items-center gap-2 px-3 py-2 rounded-md cursor-pointer hover:bg-primary-50 transition-colors"
            role="option"
          >
            <p-avatar
              [label]="user.initials"
              shape="circle"
              styleClass="bg-primary-100 text-primary-700 font-semibold text-xs w-7 h-7"
            />
            <span class="text-sm text-surface-800 truncate">{{ user.fullName }}</span>
          </li>
        }
        @if (filteredUsers().length === 0) {
          <li class="px-3 py-2 text-sm text-surface-400 text-center">No users found</li>
        }
      </ul>
    }

    @if (mentionType() === 'todo') {
      <ul aria-label="Todo mentions" class="py-1" role="listbox">
        @for (todo of filteredTodos(); track $index; let i = $index) {
          <li
            (click)="selectTodo(todo)"
            [class.bg-primary-50]="mentionActiveIndex() === i"
            class="flex items-center gap-2 px-3 py-2 rounded-md cursor-pointer hover:bg-primary-50 transition-colors"
            role="option"
          >
            <i class="pi pi-check-square text-primary-500 text-sm shrink-0"></i>
            <span class="text-sm text-surface-800 truncate">{{ todo.title }}</span>
          </li>
        }
        @if (filteredTodos().length === 0) {
          <li class="px-3 py-2 text-sm text-surface-400 text-center">No tasks found</li>
        }
      </ul>
    }

  </div>
</p-popover>
